// extracted by mini-css-extract-plugin
module.exports = {"base":"DevMode_base__1r8we","button":"DevMode_button__28Adw"};